import {
  ACCRELEASETRANS_LOADING,
  GET_ACCRELEASETRANS,
  GET_ACCRELEASETRANS_ONE,
  GET_ACCRELEASETRANS_SUCCESS,
  GET_ACCRELEASETRANS_FAIL,
  ADD_NEW_ACCRELEASETRANS,
  ADD_ACCRELEASETRANS_SUCCESS,
  ADD_ACCRELEASETRANS_FAIL,
  DELETE_ACCRELEASETRANS_SUCCESS,
  DELETE_ACCRELEASETRANS_FAIL,
  UPDATE_ACCRELEASETRANS_SUCCESS,
  UPDATE_ACCRELEASETRANS_FAIL,
  ACCRELEASETRANS_RESET
} from "./actionType";

const INIT_STATE = {
  accReleaseTranss: [],
  accReleaseTransOne: {},
  error: {},
};

const accReleaseTrans = (state = INIT_STATE, action) => {

  switch (action.type) {
    case GET_ACCRELEASETRANS_SUCCESS:
      switch (action.payload.actionType) {
        case GET_ACCRELEASETRANS:
          return {
            ...state,
            accReleaseTranss: action.payload.data,
            isAccReleaseTransCreated: false,
            isAccReleaseTransSuccess: true,
            loading: false,
          };

        case GET_ACCRELEASETRANS_ONE:
          return {
            ...state,
            accReleaseTransOne: action.payload.data,
            isAccReleaseTransCreated: false,
            isAccReleaseTransSuccess: true,
            loading: false,
          };


        default:
          return { ...state };
      }
    case GET_ACCRELEASETRANS_FAIL:
      switch (action.payload.actionType) {
        case GET_ACCRELEASETRANS_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isAccReleaseTransCreated: false,
            isAccReleaseTransSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_ACCRELEASETRANS: {
      return {
        ...state,
        isAccReleaseTransCreated: false,
        loading: true,
      };
    }

    case GET_ACCRELEASETRANS_ONE: {
      return {
        ...state,
        accReleaseTransOne: action.payload.data,
        isAccReleaseTransCreated: false,
        loading: true,
      };
    }

    case ACCRELEASETRANS_LOADING: {
      return {
        ...state,
        isAccReleaseTransCreated: false,
        loading: true,
      };
    }

    case ADD_ACCRELEASETRANS_SUCCESS:
      return {
        ...state,
        isAccReleaseTransCreated: true,
        loading: false,
        accReleaseTranss: [action.payload.data, ...state.accReleaseTranss],
      };

    case ADD_ACCRELEASETRANS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_ACCRELEASETRANS_SUCCESS:
      return {
        ...state,
        loading: false,
        isAccReleaseTransCreated: true,
        accReleaseTranss: state.accReleaseTranss.filter(
          accReleaseTrans => accReleaseTrans.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_ACCRELEASETRANS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_ACCRELEASETRANS_SUCCESS:
      return {
        ...state,
        loading: false,
        accReleaseTranss: state.accReleaseTranss.map(accReleaseTrans =>
          accReleaseTrans.id.toString() === action.payload.data.id.toString() ? { ...accReleaseTrans, ...action.payload.data } : accReleaseTrans
        ),
      };

    case UPDATE_ACCRELEASETRANS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case ACCRELEASETRANS_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default accReleaseTrans;